export default __webpack_public_path__ + "static/media/commingSoonedit2.04540155.png";